import React from 'react';
import { connect } from 'react-redux';

import { Select, TreeSelector } from 'redpoints-front-components/index';

import {
  allIncidentsFiltersSetEnforcementStatus,
  allIncidentsFiltersSetEnforcementStatusGroup,
} from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsFiltersEnforcementStatusGroupSelected,
  getAllIncidentsFiltersEnforcementStatusSelected,
  getAllIncidentsFiltersLinkStatusTreeData,
} from '../../../reducers/reporting/allIncidents';
import { REPORT_TYPE } from './AllIncidents';
import { translate } from '../../../helpers/languageHelper';
import { getTreeKeysSelected } from './formDataHelpers';

const AllIncidentsFiltersLinkStatus = ({
  allIncidentsFiltersSetEnforcementStatus,
  allIncidentsFiltersSetEnforcementStatusGroup,
  enforcementStatusGroupSelected,
  enforcementStatusSelected,
  linkStatusTreeData,
  reportType,
}) => {
  const handleOnFilterChange = values => {
    const output = {};
    (values || []).forEach(value => {
      const [type, typeId] = value.split('_');
      output[type] = [...(output[type] || []), typeId];
    });
    allIncidentsFiltersSetEnforcementStatusGroup({
      enforcementStatusGroupId: output['enforcementStatusGroup'],
    });
    allIncidentsFiltersSetEnforcementStatus({
      enforcementStatus: output['enforcementStatus'],
    });
  };

  if (reportType === REPORT_TYPE.INTERNAL) {
    return (
      <TreeSelector
        aria-label="link-status"
        className="link-status-tree"
        label={translate('reporting.allIncidentsInternal.filters.linkStatus')}
        treeData={linkStatusTreeData}
        onChange={handleOnFilterChange}
        value={getTreeKeysSelected({
          enforcementStatus: enforcementStatusSelected,
          enforcementStatusGroup: enforcementStatusGroupSelected,
        })}
        placeholder={translate('common.all')}
      />
    );
  }
  if (reportType === REPORT_TYPE.CUSTOMER) {
    return (
      <Select
        allowClear={true}
        aria-label="link-status"
        mode="multiple"
        label={translate('reporting.allIncidentsInternal.filters.linkStatus')}
        data={linkStatusTreeData}
        mapping={{ key: 'key', value: 'title' }}
        placeholder={translate('common.all')}
        maxTagTextLength={10}
        value={getTreeKeysSelected({
          enforcementStatusGroup: enforcementStatusGroupSelected,
        })}
        onChange={handleOnFilterChange}
      />
    );
  }
  return null;
};

const mapStateToProps = state => ({
  enforcementStatusGroupSelected: getAllIncidentsFiltersEnforcementStatusGroupSelected(
    state
  ),
  enforcementStatusSelected: getAllIncidentsFiltersEnforcementStatusSelected(
    state
  ),
  linkStatusTreeData: getAllIncidentsFiltersLinkStatusTreeData(state),
});

export default connect(mapStateToProps, {
  allIncidentsFiltersSetEnforcementStatus,
  allIncidentsFiltersSetEnforcementStatusGroup,
})(AllIncidentsFiltersLinkStatus);
